import React from 'react';
import { useState, useEffect } from 'react';
import CustomInputValue from '../../../components/Elements/inputWithValue/customInputValue';
import ChooseUserOption from '../../chooseUserBuy/chooseUser/chooseUserOption/chooseUserOption';
import CustomButtons from '../../../components/Elements/Buttons/customButton';
import ApiService from '../../../services/ApiService';
import './yoursConsent.css';

const YoursConsent = (props) => {
    const apiService = ApiService.getInstance();
    const [formData, setFormData] = useState({
        personalDataConsent: props.userData.personalDataProcessingConsent,
        contactConsent: props.userData.personalDataProcessingConsent,
        markietingConsent: props.userData.marketingAgreement,
        markietingConsentSms: props.userData.consentReceiveSmsEmailPhone,
    });

    const [user, setUser] = useState();

    const [msg, setMsg] = useState('');

    function saveUserConsent() {
      
        let consent = {
            usersID: props.userData.usersID,
            marketingAgreement: formData.markietingConsent ? true : false,
            consentReceiveSmsEmailPhone: formData.markietingConsentSms ? true : false,
        };
   
        apiService.apiPost(
            'UpdateUserConsents',
            consent,
            (response) => {
                setMsg(response.data.message);
            },
            false
        );
    }

    useEffect(() => {
        apiService.apiGet('UserGet', (response) => {
         
            if (response.success) {
                setUser(response.data);
                setFormData({
                    ...formData,
                    ...{
                        personalDataConsent: response.data.personalDataProcessingConsent,
                        contactConsent: response.data.consentReceiveSmsEmailPhone,
                        markietingConsent: response.data.marketingAgreement,
                    },
                });
            } else {
            }
        });
    }, [props.userData]);

    return (
        <>
            <div className="personalData_content">
                <div className="chooseConection consentArea">
                    <ChooseUserOption
hintMsg = "Pole nie może być edytowane"
                        isChekcked={true}
                        onCheck={(e) => {}}
                        label="Zgoda na przetwarzanie danych osobowych*"
                    ></ChooseUserOption>
                    <div style={{ height: '10px' }}></div>
                    <ChooseUserOption
                        isChekcked={true}
                        hintMsg = "Pole nie może być edytowane"
                        onCheck={(e) => {
                            if (formData.contactConsent) {
                                setFormData({
                                    ...formData,
                                    ...{ contactConsent: false },
                                });
                            } else {
                                setFormData({
                                    ...formData,
                                    ...{ contactConsent: true },
                                });
                            }
                        }}
                        label="Zgoda na SMS/Email/Telefon"
                    ></ChooseUserOption>
                    <div style={{ height: '10px' }}></div>
                    <ChooseUserOption
                        isChekcked={formData.markietingConsentSms}
                        onCheck={(e) => {
                            if (formData.markietingConsentSms) {
                                setFormData({
                                    ...formData,
                                    ...{ markietingConsentSms: false },
                                });
                            } else {
                                setFormData({
                                    ...formData,
                                    ...{ markietingConsentSms: true },
                                });
                            }
                        }}
                        label="Wyrażam zgodę na otrzymywanie informacji marketingowych i handlowych drogą elektroniczną, za pośrednictwem automatycznych systemów wywołujących oraz telefonicznie z wykorzystaniem telekomunikacyjnych urządzeń końcowych."
                    ></ChooseUserOption>
                    <ChooseUserOption
                        isChekcked={formData.markietingConsent}
                        onCheck={(e) => {
                            if (formData.markietingConsent) {
                                setFormData({
                                    ...formData,
                                    ...{ markietingConsent: false },
                                });
                            } else {
                                setFormData({
                                    ...formData,
                                    ...{ markietingConsent: true },
                                });
                            }
                        }}
                        label="Wyrażam zgodę na przetwarzanie moich danych osobowych w celach marketingowych promujących towary i usługi Administratora, a także w celach promujących towary i usługi partnerów, których lista dostępna jest pod adresem strony www.egurrola.com/partnerzy/."
                    ></ChooseUserOption>
                </div>
                {msg != '' ? <p className="errorText">{msg}</p> : ''}
                <CustomButtons clickFunction={saveUserConsent} size="small" classButton="solid">
                    ZAPISZ
                </CustomButtons>
            </div>
        </>
    );
};

export default YoursConsent;
